import { render } from "./MenuRoutes.vue?vue&type=template&id=ce270700"
import script from "./MenuRoutes.vue?vue&type=script&lang=js"
export * from "./MenuRoutes.vue?vue&type=script&lang=js"

import "./MenuRoutes.vue?vue&type=style&index=0&id=ce270700&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__